"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var combineLatest_1 = require("rxjs/observable/combineLatest");
var BaseAction = /** @class */ (function () {
    function BaseAction() {
        this.conditions = [];
    }
    BaseAction.prototype.addCondition = function (condition) {
        this.conditions.push(condition);
    };
    BaseAction.prototype.invoke = function () {
        var _this = this;
        if (!this.conditions || !this.conditions.length) {
            this.act();
            return;
        }
        this.subscription = combineLatest_1.combineLatest(this.conditions.map(function (c) { return c.observable; }))
            .subscribe(function (values) {
            // exit if any condition failed
            if (values.some(function (v) { return !v; })) {
                return;
            }
            console.log("Running " + _this.constructor.name + " action...");
            _this.act();
        });
    };
    BaseAction.prototype.cancel = function () {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    };
    return BaseAction;
}());
exports.BaseAction = BaseAction;
